<template>
  <div class="demo-container" ref="container">
    <div class="demo" :data-noscroll="overlayPanel?true:false" :data-guided="guidedMode" :data-show-links="showLinks">

      <div class="screens">

        <!-- DASHBOARD -->
        <div class="screen" data-screen="dashboard" :data-active="currentScreen=='dashboard'">
          <img class="w-full max-w-100" src="/img/screens/hb-employee-dashboard.png" />
          <div class="links">



            <screen-link left="29%" top="48%" width="16%" height="4%" data-tgt="hb-enrollment-begin" @click.native="onLinkClick"></screen-link>
            <screen-link left="47.75%" top="21%" width="19.25%" height="10%" data-tgt="hb-summary" @click.native="onLinkClick"></screen-link>

            <info-box top="12%" width="15%" left="0%"  align="left top">
              <p>This main dashboard in the employee view was specifically designed to give your employees the most frequently accessed information right at their fingertips</p>
            </info-box>

            <info-box top="33%" width="15%" left="0%"  align="left top">
              <p>Here the employee can view the summary of benefit selections for them and their dependents.</p>
            </info-box>


            <info-box top="49.5%" width="15%" left="12.5%"  align="right top">
              <p>When the employee is newly eligible or in the midst of enrolling for benefits, this tile will allow them to begin or resume their enrollment.</p>
            </info-box>



          </div>
        </div>






        <!-- ENROLLMENT -->



        <div class="screen" data-screen="hb-enrollment-begin" :data-active="currentScreen=='hb-enrollment-begin'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-begin.png" />
          <div class="links">
            <screen-link left="78%" top="64%" width="7%" height="6%" data-tgt="hb-enrollment-dependents" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-dependents" :data-active="currentScreen=='hb-enrollment-dependents'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-dependents.png" />
          <div class="links">
            <screen-link left="79%" top="60%" width="7%" height="6%" data-tgt="hb-enrollment-dependents-add" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-dependents-add" :data-active="currentScreen=='hb-enrollment-dependents-add'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-dependents-add.png" />
          <div class="links">
            <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-enrollment-dependents" @click.native="onLinkClick"></screen-link>
            <screen-link left="85.5%" top="7.5%" width="5.5%" height="4%" data-tgt="hb-enrollment-dependents" @click.native="onLinkClick"></screen-link>
            <screen-link left="63%" top="20%" width="35%" height="60%" data-tgt="hb-enrollment-dependents-add-husband" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-dependents-add-husband" :data-active="currentScreen=='hb-enrollment-dependents-add-husband'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-dependents-add-husband.png" />
          <div class="links">
            <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-enrollment-dependents" @click.native="onLinkClick"></screen-link>
            <screen-link left="85.5%" top="7.5%" width="5.5%" height="4%" data-tgt="hb-enrollment-dependents" @click.native="onLinkClick"></screen-link>
            <screen-link left="91.2%" top="7.5%" width="5.5%" height="4%" data-tgt="hb-enrollment-dependents-add-husband-save" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-dependents-add-husband-save" :data-active="currentScreen=='hb-enrollment-dependents-add-husband-save'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-dependents-add-husband-save.png" />
          <div class="links">
            <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-enrollment-dependents-husband-added" @click.native="onLinkClick"></screen-link>
            <screen-link left="85.5%" top="7.5%" width="5.5%" height="4%" data-tgt="hb-enrollment-dependents" @click.native="onLinkClick"></screen-link>
            <screen-link left="91.2%" top="7.5%" width="5.5%" height="4%" data-tgt="hb-enrollment-dependents-add-husband" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-dependents-husband-added" :data-active="currentScreen=='hb-enrollment-dependents-husband-added'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-dependents-husband-added.png" />
          <div class="links">
            <screen-link left="80%" top="77%" width="7%" height="6%" data-tgt="hb-enrollment-medical" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-medical" :data-active="currentScreen=='hb-enrollment-medical'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-medical.png" />
          <div class="links">
            <screen-link left="79.5%" top="60%" width="6.5%" height="6%" data-tgt="hb-enrollment-medical-uhc" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-medical-uhc" :data-active="currentScreen=='hb-enrollment-medical-uhc'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-medical-uhc.png" />
          <div class="links">
            <screen-link left="79.5%" top="129%" width="6.5%" height="6%" data-tgt="hb-enrollment-medical-uhc-selectspouse" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-medical-uhc-selectspouse" :data-active="currentScreen=='hb-enrollment-medical-uhc-selectspouse'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-medical-uhc-selectspouse.png" />
          <div class="links">
            <screen-link left="78%" top="129%" width="8%" height="6%" data-tgt="hb-enrollment-medical-uhc" @click.native="onLinkClick"></screen-link>
            <screen-link left="27.5%" top="199%" width="6.5%" height="6%" data-tgt="hb-enrollment-dependents-husband-added" @click.native="onLinkClick"></screen-link>
            <screen-link left="80%" top="199%" width="6.5%" height="6%" data-tgt="hb-enrollment-dental" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-dental" :data-active="currentScreen=='hb-enrollment-dental'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-dental.png" />
          <div class="links">
            <screen-link left="79%" top="112.5%" width="7%" height="6%" data-tgt="hb-enrollment-dental-spouse" @click.native="onLinkClick"></screen-link>
            <screen-link left="27.5%" top="175%" width="6.5%" height="6%" data-tgt="hb-enrollment-medical-uhc-selectspouse" @click.native="onLinkClick"></screen-link>


          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-dental-spouse" :data-active="currentScreen=='hb-enrollment-dental-spouse'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-dental-spouse.png" />
          <div class="links">
            <screen-link left="77%" top="112.5%" width="9%" height="6%" data-tgt="hb-enrollment-dental" @click.native="onLinkClick"></screen-link>
            <screen-link left="27.5%" top="175%" width="6.5%" height="6%" data-tgt="hb-enrollment-medical-uhc-selectspouse" @click.native="onLinkClick"></screen-link>
            <screen-link left="80%" top="175%" width="6.5%" height="6%" data-tgt="hb-enrollment-vision" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-vision" :data-active="currentScreen=='hb-enrollment-vision'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-vision.png" />
          <div class="links">

            <screen-link left="27.5%" top="175%" width="6.5%" height="6%" data-tgt="hb-enrollment-dental-spouse" @click.native="onLinkClick"></screen-link>
            <screen-link left="80%" top="175%" width="6.5%" height="6%" data-tgt="hb-enrollment-life" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-life" :data-active="currentScreen=='hb-enrollment-life'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-life.png" />
          <div class="links">

            <screen-link left="27.5%" top="78.5%" width="6.5%" height="6%" data-tgt="hb-enrollment-vision" @click.native="onLinkClick"></screen-link>
            <screen-link left="80%" top="60.5%" width="5.5%" height="5.0%" data-tgt="hb-enrollment-life-select" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-life-select" :data-active="currentScreen=='hb-enrollment-life-select'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-life-select.png" />
          <div class="links">

            <screen-link left="27.5%" top="100%" width="6.5%" height="6%" data-tgt="hb-enrollment-vision" @click.native="onLinkClick"></screen-link>
            <screen-link left="28%" top="86%" width="12%" height="7%" data-tgt="hb-enrollment-life-select-100000" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-life-select-100000" :data-active="currentScreen=='hb-enrollment-life-select-100000'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-life-select-100000.png" />
          <div class="links">

            <screen-link left="27.5%" top="100%" width="6.5%" height="6%" data-tgt="hb-enrollment-vision" @click.native="onLinkClick"></screen-link>
            <screen-link left="80%" top="100%" width="7%" height="5.75%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
            <flex-info left="39.75%" top="78%">The selected amount will be pending approval from the carrier before being added to your per pay period total.</flex-info>
          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-beneficiaries" :data-active="currentScreen=='hb-enrollment-beneficiaries'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries.png" />
          <div class="links">

            <screen-link left="27.5%" top="84%" width="6.5%" height="6%" data-tgt="hb-enrollment-life-select-100000" @click.native="onLinkClick"></screen-link>
            <screen-link left="79%" top="69%" width="7%" height="5.75%" data-tgt="hb-enrollment-beneficiaries-add" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-beneficiaries-add" :data-active="currentScreen=='hb-enrollment-beneficiaries-add'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries-add.png" />
          <div class="links">

            <screen-link left="63%" top="14%" width="36%" height="7%" data-tgt="hb-enrollment-beneficiaries-add-primary" @click.native="onLinkClick"></screen-link>
            <screen-link left="85.25%" top="7%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
            <screen-link left="97%" top="7%" width="2.5%" height="5.5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-beneficiaries-add-primary" :data-active="currentScreen=='hb-enrollment-beneficiaries-add-primary'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries-add-primary.png" />
          <div class="links">


            <screen-link left="87%" top="11.5%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
            <screen-link left="97%" top="7%" width="2.5%" height="5.5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
            <screen-link left="92%" top="29%" width="6.5%" height="6%" data-tgt="hb-enrollment-beneficiaries-add-primary-selected" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-beneficiaries-add-primary-selected" :data-active="currentScreen=='hb-enrollment-beneficiaries-add-primary-selected'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries-add-primary-selected.png" />
          <div class="links">


            <screen-link left="87%" top="11.5%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
            <screen-link left="93%" top="11.5%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries-add-primary-distribution" @click.native="onLinkClick"></screen-link>
            <screen-link left="97%" top="7%" width="2.5%" height="5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
            <screen-link left="90%" top="29%" width="8.5%" height="6%" data-tgt="hb-enrollment-beneficiaries-add-primary" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-beneficiaries-add-primary-distribution" :data-active="currentScreen=='hb-enrollment-beneficiaries-add-primary-distribution'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries-add-primary-distribution.png" />
          <div class="links">


            <screen-link left="85%" top="7%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
            <screen-link left="97%" top="7%" width="2.5%" height="5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
            <screen-link left="88%" top="35%" width="8.5%" height="6%" data-tgt="hb-enrollment-beneficiaries-add-primary-distribution-100" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-beneficiaries-add-primary-distribution-100" :data-active="currentScreen=='hb-enrollment-beneficiaries-add-primary-distribution-100'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries-add-primary-distribution-100.png" />
          <div class="links">


            <screen-link left="85%" top="7%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
            <screen-link left="97%" top="7%" width="2.5%" height="5%" data-tgt="hb-enrollment-beneficiaries" @click.native="onLinkClick"></screen-link>
            <screen-link left="91%" top="7%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries-added" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-beneficiaries-added" :data-active="currentScreen=='hb-enrollment-beneficiaries-added'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries-added.png" />
          <div class="links">

            <screen-link left="79%" top="69%" width="7%" height="5.75%" data-tgt="hb-enrollment-beneficiaries-edit" @click.native="onLinkClick"></screen-link>
            <screen-link left="27.5%" top="104%" width="6.5%" height="6%" data-tgt="hb-enrollment-life-select-100000" @click.native="onLinkClick"></screen-link>
            <screen-link left="80%" top="104%" width="7%" height="5.75%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-beneficiaries-edit" :data-active="currentScreen=='hb-enrollment-beneficiaries-edit'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-beneficiaries-edit.png" />
          <div class="links">

            <screen-link left="85%" top="7%" width="6%" height="5.5%" data-tgt="hb-enrollment-beneficiaries-added" @click.native="onLinkClick"></screen-link>
            <screen-link left="97%" top="7%" width="2.5%" height="5%" data-tgt="hb-enrollment-beneficiaries-added" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-review" :data-active="currentScreen=='hb-enrollment-review'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-review.png" />
          <div class="links">

            <screen-link left="79%" top="59%" width="7%" height="5.75%" data-tgt="hb-enrollment-change-medical" @click.native="onLinkClick"></screen-link>
            <screen-link left="79%" top="85.5%" width="7%" height="5.75%" data-tgt="hb-enrollment-review-edit-beneficiary" @click.native="onLinkClick"></screen-link>

            <screen-link left="27.5%" top="120.5%" width="6.5%" height="6%" data-tgt="hb-enrollment-beneficiaries-added" @click.native="onLinkClick"></screen-link>
            <screen-link left="57%" top="120.5%" width="3%" height="5.75%" data-tgt="hb-enrollment-review-accept" @click.native="onLinkClick"></screen-link>
            <screen-link left="70.5%" top="120.5%" width="7%" height="5.75%" data-tgt="hb-enrollment-review-legal-notice" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-change-medical" :data-active="currentScreen=='hb-enrollment-change-medical'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-change-medical.png" />
          <div class="links">

            <screen-link left="73%" top="199%" width="6.5%" height="6%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-review-edit-beneficiary" :data-active="currentScreen=='hb-enrollment-review-edit-beneficiary'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-review-edit-beneficiary.png" />
          <div class="links">

            <screen-link left="85%" top="7%" width="6%" height="5.5%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>
            <screen-link left="97%" top="7%" width="2.5%" height="5%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-review-legal-notice" :data-active="currentScreen=='hb-enrollment-review-legal-notice'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-review-legal-notice.png" />
          <div class="links">


            <screen-link left="97%" top="7%" width="2.5%" height="5%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-review-accept" :data-active="currentScreen=='hb-enrollment-review-accept'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-review-accept.png" />
          <div class="links">

            <screen-link left="79%" top="59%" width="7%" height="5.75%" data-tgt="hb-enrollment-change-medical" @click.native="onLinkClick"></screen-link>
            <screen-link left="79%" top="85.5%" width="7%" height="5.75%" data-tgt="hb-enrollment-review-edit-beneficiary" @click.native="onLinkClick"></screen-link>

            <screen-link left="27.5%" top="120.5%" width="6.5%" height="6%" data-tgt="hb-enrollment-beneficiaries-added" @click.native="onLinkClick"></screen-link>
            <screen-link left="57%" top="120.5%" width="3%" height="5.75%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>
            <screen-link left="70.5%" top="120.5%" width="7%" height="5.75%" data-tgt="hb-enrollment-review-legal-notice" @click.native="onLinkClick"></screen-link>
            <screen-link left="80%" top="120.5%" width="7%" height="5.75%" data-tgt="hb-enrollment-confirmation" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen" data-screen="hb-enrollment-confirmation" :data-active="currentScreen=='hb-enrollment-confirmation'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-confirmation.png" />
          <div class="links">

            <screen-link left="50%" top="50%" width="15%" height="5%" data-tgt="hb-enrollment-confirmation-pdf" @click.native="onLinkClick"></screen-link>
            <screen-link left="54%" top="55%" width="6.5%" height="5.75%" data-tgt="hb-employee-post-enrollment" @click.native="onLinkClick"></screen-link>


          </div>
        </div>

        <div class="screen z-max" data-screen="hb-enrollment-confirmation-pdf" :data-active="currentScreen=='hb-enrollment-confirmation-pdf'">
          <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-confirmation-pdf.png" />
          <div class="links">

            <screen-link left="1%" top="1%" width="98%" height="98%" data-tgt="hb-enrollment-confirmation" @click.native="onLinkClick"></screen-link>


          </div>
        </div>

        <div class="screen-html" :data-active="true">
          <div class="stack-center">
            <div class="col-md">
              <div class="block">
                <img src="house-icon" />
                <div>
                  <h3>Family</h3>
                  <p>Please make sure that information about you and your family is up to date.</p>
                </div>
              </div>
              <div class="block">
                <div class="initials-icon">
                  <span>JA</span>
                </div>
                <div>
                  <h4>Jamie Alexander</h4>
                </div>
              </div>
            </div>
          </div>
        </div>



      <!-- HEADER NAV OVERLAYS -->


      <div class="overlay" data-screen="news" :data-active="overlayPanel=='news'">
        <img class="w-full max-w-100" src="/img/screens/sidepanel-news.png" />
        <div class="links">
          <screen-link left="87%" top="1.5%" width="10%" height="4%" data-tgt="" data-is-overlay="true" @click.native="onLinkClick"></screen-link>



        </div>
      </div>

      <div class="overlay" data-screen="messages" :data-active="overlayPanel=='messages'">
        <img class="w-full max-w-100" src="/img/screens/sidepanel-messages.png" />
        <div class="links">
          <screen-link left="90%" top="1%" width="10%" height="4%" data-tgt="" data-is-overlay="true" @click.native="onLinkClick"></screen-link>

        </div>
      </div>


      <flex-nav-top-bar class="z-40" :data-hidden="!visibility.topnav"  @nav-click="onTopNavLink"></flex-nav-top-bar>
      <flex-side-nav  :data-hidden="!visibility.topnav" @nav-click="onSideNavLink" :active-link="sideNavLink" :mode="sideNavMode"></flex-side-nav>
    </div>
    </div>
    <demo-menu v-if="showMenu" @fullscreen="goFullscreen"></demo-menu>
  </div>

</template>

<script>
import ScreenLink from "../components/ScreenLink";
//import FiltersPanel from "../components/FiltersPanel";

import FlexNavTopBar from "../components/FlexNavTopBar";
import FlexSideNav from "../components/FlexEmployeeSideNav";
import InfoBox from "../components/InfoBox";
//import SelectBox from "@/components/SelectBox";
import FlexInfo from "@/components/FlexInfo";
import DemoMenu from "@/components/DemoMenu";
export default {
  name: "enrollment-screens",
  components: {DemoMenu, FlexInfo, InfoBox, FlexSideNav, FlexNavTopBar, ScreenLink},
  mounted: function(){
    window.addEventListener('keydown',this.onKeyDown);
    window.addEventListener('keyup',this.onKeyUp);
  },
  props: {},
  data: function () {
    return {
      defaultScreen: 'dashboard',
      visibility: {
        topnav: true
      },
      overlayPanel: null,
      pulloutPanel: null,
      disableScreenScoll: false,
      showLinks: false,


      employeeSelections: [
        { label: "All Employees", tgt: "hb-employees-all"},
        { label: "Newly Eligible", tgt: "hb-employees-newly"},
        { label: "Annual Enrollment", tgt: "hb-employees-annual"},
        { label: "Current Enrollment", tgt: "hb-employees-current"},
        { label: "Future Enrollment", tgt: "hb-employees-future"},
        { label: "Missing Information", tgt: "hb-employees-missing"},

      ],

      planClassificationsMedical: [
        { label: "MANAGEMENT", tgt: "hb-plans-medical"},
        { label: "HOURLY", tgt: "hb-plans-medical-hourly"},
      ]

    }
  },
  methods: {

    goFullscreen: function(){
      this.$refs.container.firstChild.requestFullscreen();
    },

    onSetGuided: function(guided){

      //this.guidedMode = guided;
      //this.showMenu = false;

      this.$store.commit("guidedMode", guided);
      this.$store.commit("showMenu", false);

    },

    onKeyDown: function(e){
      if(e.key == "Shift"){
        this.showLinks = true;
      }

      if(e.key == " "){
        this.$store.commit("showMenu", true);
      }
    },

    onKeyUp: function(e){
      console.log(e.key);
      if(e.key == "Shift"){
        this.showLinks = false;
      }


    },

    onLinkClick: function(e){
      // this.currentScreen = e.target.dataset.tgt;

      if(!e.target.dataset.tgt && this.pulloutPanel) {
        this.pulloutPanel = null;
      }else if(e.target.dataset.isOverlay){
        this.overlayPanel = e.target.dataset.tgt
      }else{
        this.setScreen(e.target.dataset.tgt);
      }


    },

    showPullout: function(e){
      // this.currentScreen = e.target.dataset.tgt;
      this.pulloutPanel = e.target.dataset.tgt
    },

    onSelectClick: function(tgt){
      // this.currentScreen = e.target.dataset.tgt;

      this.setScreen(tgt);



    },

    setScreen: function(id, mode){
      this.overlayPanel = null;
      this.pulloutPanel = null;

      if(!mode){
        mode = "enrollment"
      }

      if(id == this.$route.params.screen){
        //this.$router.go(0);
      }else{
        this.$router.push({name: mode, params: { screen: id}});
      }

    },

    onFilterEmployees: function(selections){
      console.log(selections);
      this.setScreen('hb-employees-all');
    },

    toggleViz: function(key){
      this.visibility[key] = !this.visibility[key];
    },

    onSideNavLink: function(link){
      if(link){
        let linkParams = link.split(":");
        if(linkParams[0] == "hb"){

          this.$router.push({name: "employee", params: { screen: linkParams[1]}});

        }else if(linkParams[0] == "dashboard"){

          this.$router.push({name: "employee", params: { screen: linkParams[1]}});

        }
      }

    },

    onTopNavLink: function(link){


      if(link){
        let linkParams = link.split(":");
        if(linkParams[0] == "pullout"){
          this.showOverlay(linkParams[1]);

        }
      }

    },

    showOverlay: function(id){
      this.overlayPanel = id;
    }
  },
  computed: {

    showMenu: function(){
      return this.$store.state.showMenu;
    },

    guidedMode: function(){
      return this.$store.state.guidedMode;
    },
    currentScreen: function(){
      if(this.$route.params.screen){
        return this.$route.params.screen;
      }else{
        return this.defaultScreen;
      }
    },

    sideNavLink: function(){
      if(this.$route.params.screen){
        return this.$route.params.screen.split("-")[0];
      }else{
        return "dashboard";
      }
    },

    sideNavMode: function(){
      if(this.$route.query.mode){
        return this.$route.query.mode;
      }else{
        return "admin";
      }
    }
  }
}
</script>

<style scoped>

img {
  margin: 0;
}

.demo-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  padding-bottom: calc((920/1580) * 100%);
  max-width: 1580px;
  background-repeat: repeat-y;
  background-image: url(../assets/screen-bkg.png);
  background-size: 100% 10%;

  font-size: 1vw;


}


.demo {
  width: 100%;
  position: absolute;
  height: 100%;
  background-repeat: repeat-y;
  background-image: url(../assets/screen-bkg.png);
  background-size: 100% 10%;
  overflow-y:hidden;
  overflow-x: hidden;



}

.demo[data-noscroll="true"]{
  overflow-y: hidden;

}



.screens {

  position: relative;
  width: 100%;
  height: 100%;
  overflow-y:scroll;
  overflow-x: hidden;
}

.overlay {
  position: absolute;
  width: calc((320/1580) * 100%);
  top: calc((60/920) * 100%);
  right: 0;
  display: none;
}

.overlay[data-active="true"] {
  display: block;
}

.pullout {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  display: none;
  background-color: rgba(0,0,0,0.49);
}

.pullout[data-active="true"] {
  display: block;
}

.overlay[data-active="true"] {
  display: block;
}

.screens .screen {
  position: relative;
  width: 100%;
  display: none;
}

.screens .screen-html {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.screen[data-active="true"] {
  display: block;
}

.screen .links {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  padding-top: calc((920/1580) * 100%);
}

.pullout .links {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  padding-top: calc((920/1580) * 100%);
}


/* UTILITIES */

.w-full {
  width: 100%;
}

.max-w-100 {
  max-width: 1580px;
}

.pullout-1200 {
  position: absolute;
  width: calc(100% * (1200 / 3160));
  top: 0;
  right: 0;
}

.x-ray {
  opacity: 0.5;
}

*[data-hidden] {
  opacity: 0;
}

.demo[data-show-links="true"] .screen-link {
  border: 2px solid var(--color-green);
}

.demo[data-show-links="true"] .select-box {
  border: 2px solid var(--color-green);
}

.demo[data-show-links="true"] .flex-info {
  border: 2px solid var(--color-green);
}

.demo[data-show-links="true"] .info-box {
  display: block;
}

.demo .info-box {
  display: none;
}


.demo[data-guided="true"] .info-box {
  display: block;
}

.z-max {
  z-index: 50;
}

.z-40 {
  z-index: 40;
}

.info-box {
  z-index: 30;
}


.screen-html {
  padding-left: calc((100/1580) * 100%);
}

.stack-center {
  display: flex;
  justify-content: center;

  position: relative;
}

.col-md {
  width: 100%;
  max-width: 55em;
}


.block {
  width: 100%;
  position: relative;
  background-color: white;
  padding: 1em;
}





</style>